module.exports = __webpack_public_path__ + "img/rc-logo-1.895fa653.png";